export default __webpack_public_path__ + "static/media/Background 5_00078.653f2059.png";